import { Injectable } from '@angular/core';

declare global {
	interface Window {
		dataLayer: Record<string, unknown>[];
	}
}

@Injectable({ providedIn: 'root' })
export class GoogleTagManagerService {
	private isInitialized = false;

	initialize(gtmId: string): void {
		if (this.isInitialized || !gtmId) {
			return;
		}

		window.dataLayer = window.dataLayer || [];

		const script = document.createElement('script');
		script.async = true;
		script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;

		window.dataLayer.push({
			'gtm.start': new Date().getTime(),
			'event': 'gtm.js'
		});

		document.head.insertBefore(script, document.head.firstChild);

		const noscript = document.createElement('noscript');
		const iframe = document.createElement('iframe');
		iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
		iframe.height = '0';
		iframe.width = '0';
		iframe.style.display = 'none';
		iframe.style.visibility = 'hidden';
		noscript.appendChild(iframe);
		document.body.insertBefore(noscript, document.body.firstChild);

		this.isInitialized = true;
	}

	pushTag(tag: Record<string, unknown>): void {
		if (!window.dataLayer) {
			window.dataLayer = [];
		}
		window.dataLayer.push(tag);
	}
}
